import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import "./tip.js";
import "./quickshop.js";